export const articleList = [
  {
    id: "a01",
    title: "热播剧收官夜冲上热搜第一，男女主这段即兴互动被反复回放",
    summary:
      "昨晚的收官直播连线里，两位主演临场加了一段没有台本的告别对话，短短三分钟就冲上热搜榜首。网友逐帧分析后发现，这句台词其实是演员自己改的。",
    category: "影视剧集",
    categorySlug: "film-tv",
    author: "吃瓜小分队",
    date: "2026-09-10",
    readTime: "5 分钟",
    image: "https://readdy.ai/api/search-image?query=editorial%20entertainment%20magazine%20visual%20of%20a%20warm%20lit%20tv%20studio%20with%20spotlights%20and%20glowing%20screen%20abstract%20bold%20orange%20tones%20cinematic%20minimal%20composition&width=800&height=560&seq=gossip-a01&orientation=landscape",
    tags: ["热播剧", "收官", "即兴表演"],
    heat: 9820000,
    comments: 4218,
    featured: true,
    content: [
      "昨晚一档热播剧的收官特别直播，把整个社交平台的热度推到了顶点。原本只是一场常规的连麦告别，两位主演却在直播后半段临时脱稿，聊起了拍摄期间最难忘的一件事。",
      "这段没有台本的对话持续了不到三分钟，但因为一句临场改动的台词，弹幕瞬间刷屏。有细心的观众翻出剧本片段对比，发现这句台词在原本的版本里并不存在，是演员在拍摄当天现场加的。",
      "导演随后在个人账号回应，称当时自己也没喊停，因为「那一瞬间的情绪比剧本更真实」。这段话被截图传播后，迅速成为讨论焦点，相关话题在短短两小时内冲上热搜榜首。",
      "截至发稿前，该话题的阅读量仍在持续增长。不少网友表示，比起精心设计的宣传，这种临场的真实感才是追剧最大的乐趣。我们也会继续关注后续的片方回应。",
    ],
  },
  {
    id: "a02",
    title: "音乐节突发暴雨，歌手返场加唱三首，全场大合唱视频破圈",
    summary:
      "音乐节最后一场遇上突如其来的暴雨，台上台下都没有散场，歌手临时决定返场加唱，现场观众举着手机灯完成了一次意料之外的合唱。",
    category: "综艺热点",
    categorySlug: "variety",
    author: "现场观察员",
    date: "2026-09-10",
    readTime: "4 分钟",
    image: "https://readdy.ai/api/search-image?query=music%20festival%20stage%20at%20night%20with%20heavy%20rain%20and%20crowd%20phone%20lights%20abstract%20warm%20amber%20glow%20cinematic%20wide%20shot%20editorial%20style&width=800&height=560&seq=gossip-a02&orientation=landscape",
    tags: ["音乐节", "现场", "合唱"],
    heat: 8560000,
    comments: 3102,
    featured: true,
    content: [
      "一场户外音乐节的压轴演出遭遇了入秋以来最大的一场暴雨。主办方一度准备提前结束，但台上的歌手在雨里拿起麦克风说了一句「既然都湿了，那就唱完」。",
      "随后乐队即兴返场，加唱了三首并未列入歌单的老歌。台下观众没有离场，反而举起手机灯跟着合唱，画面在雨幕里格外有感染力。",
      "有观众把现场视频发到网上后迅速走红，评论区里最多的一句话是「隔着屏幕都起鸡皮疙瘩」。音乐节官方账号也转发了这段视频，并感谢了坚持到最后的观众。",
      "这场意外的加演，反而成了今年音乐节被提及最多的一段名场面。",
    ],
  },
  {
    id: "a03",
    title: "新综艺开播即出圈，素人嘉宾一句话让观察室集体沉默",
    summary:
      "全新职场观察类综艺上线首期就拿下讨论度前列，节目里一位素人嘉宾的坦白，让坐在观察室的几位常驻当场沉默了好几秒。",
    category: "综艺热点",
    categorySlug: "variety",
    author: "综艺放大镜",
    date: "2026-09-09",
    readTime: "6 分钟",
    image: "https://readdy.ai/api/search-image?query=modern%20tv%20variety%20show%20observation%20room%20abstract%20interior%20warm%20neutral%20tones%20soft%20studio%20lighting%20editorial%20magazine%20composition&width=800&height=560&seq=gossip-a03&orientation=landscape",
    tags: ["新综艺", "观察室", "名场面"],
    heat: 7430000,
    comments: 2870,
    featured: false,
    content: [
      "这档职场观察类综艺在开播前并没有太多宣传，首期上线后却凭借一段不加修饰的对话登上了讨论榜前列。",
      "节目里一位素人嘉宾在被问到「最想对过去的自己说什么」时，没有按套路给出励志答案，而是坦白自己其实一直在假装喜欢这份工作。这句话说完，观察室里几位常驻嘉宾都沉默了。",
      "后期并没有给这段加上背景音乐，也没有插入花字，留白反而让情绪更有冲击力。不少观众在评论区表示，这是近期少见的「不表演的真人秀」。",
      "节目组随后回应称，这一段是完全没有剪辑修饰的原始素材，「真实本身就足够有力」。",
    ],
  },
  {
    id: "a04",
    title: "红毯造型盘点：今年最出圈的几套礼服，赢在了哪里",
    summary:
      "年度盛典红毯刚落幕，造型话题就占据了半个热搜。我们逐套拆解了讨论度最高的几身造型，看看它们到底赢在配色还是剪裁。",
    category: "时尚红毯",
    categorySlug: "fashion",
    author: "造型观察室",
    date: "2026-09-09",
    readTime: "7 分钟",
    image: "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20fashion%20gown%20silhouette%20abstract%20editorial%20visual%20warm%20gold%20and%20cream%20tones%20luxury%20minimal%20composition&width=800&height=560&seq=gossip-a04&orientation=landscape",
    tags: ["红毯", "造型", "礼服"],
    heat: 6980000,
    comments: 1930,
    featured: false,
    content: [
      "每年的盛典红毯都是造型师的一次大考。今年讨论度最高的几套造型，共同点并不是昂贵，而是「克制」。",
      "被提及最多的是一套米金色长裙，剪裁几乎没有多余装饰，靠面料的垂坠感撑起整体气质。造型师在采访中提到，这次刻意放弃了夸张的头饰，「让衣服回到衣服本身」。",
      "另一套出圈的造型则走完全相反的方向，用高饱和的暖橘色做大面积铺陈，在合影环节一眼就能被认出来。两种思路没有高下，但都说明了一件事：明确的风格比堆砌元素更重要。",
      "我们整理了这几套造型的设计思路，供喜欢研究穿搭的读者参考。",
    ],
  },
  {
    id: "a05",
    title: "实力派演员官宣新剧，搭档名单曝光后讨论量一夜翻倍",
    summary:
      "一部还未开机的现实题材新剧提前官宣阵容，两位主演的搭配出乎很多人意料，却也吊足了观众胃口。",
    category: "影视剧集",
    categorySlug: "film-tv",
    author: "剧集情报站",
    date: "2026-09-08",
    readTime: "5 分钟",
    image: "https://readdy.ai/api/search-image?query=cinematic%20film%20set%20clapperboard%20and%20warm%20studio%20light%20abstract%20editorial%20visual%20terracotta%20and%20cream%20tones%20minimal%20composition&width=800&height=560&seq=gossip-a05&orientation=landscape",
    tags: ["新剧", "官宣", "阵容"],
    heat: 6240000,
    comments: 1650,
    featured: true,
    content: [
      "这部现实题材新剧在官宣前几乎没有预热，一份简短的阵容海报却让讨论量在一夜之间翻倍。",
      "最受关注的是两位主演的搭配。一位是观众熟悉的正剧常客，另一位则长期活跃在轻喜剧领域，风格差异明显，但制作方在文案里用「意外的化学反应」来形容这次组合。",
      "有业内人士分析，这种「错位搭配」其实是近年现实题材的一种新尝试，用不同的表演质感去制造生活气息。",
      "剧集预计在年底开机，我们会持续跟进后续的拍摄动态。",
    ],
  },
  {
    id: "a06",
    title: "演唱会门票开售三秒售罄，主办方紧急宣布加开一场",
    summary:
      "巡演首站门票在开售瞬间被抢空，大量粉丝在评论区留言求加场。主办方当晚回应，将在原场地加开一场，并保留部分内场票用于抽签。",
    category: "明星动向",
    categorySlug: "stars",
    author: "巡演前线",
    date: "2026-09-08",
    readTime: "4 分钟",
    image: "https://readdy.ai/api/search-image?query=concert%20arena%20empty%20stage%20with%20warm%20amber%20stage%20lights%20abstract%20editorial%20visual%20cinematic%20wide%20composition%20minimal%20tones&width=800&height=560&seq=gossip-a06&orientation=landscape",
    tags: ["演唱会", "加场", "门票"],
    heat: 5870000,
    comments: 3420,
    featured: false,
    content: [
      "巡演首站的门票在开售瞬间售罄，页面显示「已无余票」时，距离开售还不到三秒。",
      "大量粉丝在主办方评论区留言求加场，相关话题也顺势登上热搜。当晚主办方发布公告，确认将在原场地加开一场，并拿出部分内场票用于抽签发放。",
      "公告提到，抽签面向实名注册的用户开放，每人限参与一次，结果将在开演前一周公布。",
      "对于没能抢到票的观众来说，这大概是今天最实在的一条好消息。",
    ],
  },
  {
    id: "a07",
    title: "短视频博主一条幕后花絮播放破亿，本人回应：只是随手拍的",
    summary:
      "一条原本只打算放在个人小号的花絮视频意外爆火，播放量一路涨到破亿。博主在直播里回应，自己也没想明白为什么大家这么爱看。",
    category: "网络红人",
    categorySlug: "influencer",
    author: "流量观察",
    date: "2026-09-07",
    readTime: "5 分钟",
    image: "https://readdy.ai/api/search-image?query=creator%20studio%20desk%20with%20ring%20light%20and%20camera%20abstract%20editorial%20visual%20warm%20peach%20and%20cream%20tones%20minimal%20composition&width=800&height=560&seq=gossip-a07&orientation=landscape",
    tags: ["短视频", "爆款", "幕后"],
    heat: 5310000,
    comments: 2280,
    featured: false,
    content: [
      "这条花絮视频的拍摄成本几乎为零：没有脚本，没有补光，只是随手放在桌角用手机录下了准备拍摄前的一段等待。",
      "视频里博主一直在跟镜头外的助理确认道具摆放位置，中间还打翻了两次水杯。正是这段「什么都没发生」的日常感，让播放量一路涨到破亿。",
      "在随后的直播里，博主回应说自己也没想明白，「可能大家就是想看点不加滤镜的东西」。",
      "数据分析人士指出，这条视频的完播率远高于同类账号，说明观众对过度包装的内容正在产生疲劳。",
    ],
  },
  {
    id: "a08",
    title: "综艺名场面复盘：这段即兴表演为什么被反复刷屏",
    summary:
      "一档演技类综艺里的即兴环节诞生了本季最高讨论度片段。我们复盘了这段表演的节奏设计，看看它为什么能让人一看再看。",
    category: "综艺热点",
    categorySlug: "variety",
    author: "综艺放大镜",
    date: "2026-09-07",
    readTime: "8 分钟",
    image: "https://readdy.ai/api/search-image?query=theater%20stage%20rehearsal%20with%20warm%20spotlight%20and%20empty%20seats%20abstract%20editorial%20visual%20amber%20and%20deep%20brown%20tones%20cinematic%20composition&width=800&height=560&seq=gossip-a08&orientation=landscape",
    tags: ["名场面", "即兴", "表演"],
    heat: 4920000,
    comments: 1740,
    featured: false,
    content: [
      "演技类综艺里的即兴环节向来是双刃剑，演好了是名场面，演砸了就是翻车现场。这一季争议最大的一段，恰恰成了被反复回放的高光。",
      "复盘后发现，这段表演几乎没有情绪外放的大动作，全靠几次呼吸和停顿撑住节奏。演员在对手给出台词后，有将近两秒的空白，正是这两秒让整段戏有了真实的分量。",
      "节目导师在点评时提到，即兴最忌讳的就是急着接话，「能忍住不演，才是真的会演」。",
      "这段片段目前在多个平台持续被剪辑传播，也让更多人开始讨论「表演里的留白」这个话题。",
    ],
  },
  {
    id: "a09",
    title: "电影路演现场观众提问犀利，主创一句回应收获满场掌声",
    summary:
      "一部口碑两极的电影在路演中被观众直接问到「你觉得这部片拍砸了吗」，主创没有回避，回答完之后现场响起掌声。",
    category: "影视剧集",
    categorySlug: "film-tv",
    author: "剧集情报站",
    date: "2026-09-06",
    readTime: "6 分钟",
    image: "https://readdy.ai/api/search-image?query=cinema%20screening%20room%20with%20warm%20projector%20light%20and%20empty%20red%20seats%20abstract%20editorial%20visual%20minimal%20warm%20tones&width=800&height=560&seq=gossip-a09&orientation=landscape",
    tags: ["路演", "口碑", "主创"],
    heat: 4580000,
    comments: 1390,
    featured: false,
    content: [
      "这场路演原本按流程进行，直到互动环节有观众直接提问：「网上争议这么大，你自己觉得这部片拍砸了吗？」",
      "现场短暂安静后，主创接过话筒，没有绕开问题，而是承认剪辑上确实有遗憾，同时解释了自己坚持保留某段长镜头的理由。",
      "回答结束时，观众席自发响起了掌声。有在场观众表示，不管喜不喜欢这部电影，这样的态度值得尊重。",
      "这段对话随后也被影迷整理成文字流传，成为这部影片口碑讨论里的一个转折点。",
    ],
  },
  {
    id: "a10",
    title: "歌手新专辑先行曲上线，评论区分成两派吵了一整晚",
    summary:
      "沉寂两年后的第一首新歌上线，风格与以往差别很大，评论区从晚上一直讨论到凌晨，支持与质疑的声音几乎一样多。",
    category: "明星动向",
    categorySlug: "stars",
    author: "音乐现场",
    date: "2026-09-06",
    readTime: "5 分钟",
    image: "https://readdy.ai/api/search-image?query=recording%20studio%20microphone%20with%20warm%20mood%20lighting%20abstract%20editorial%20visual%20amber%20and%20charcoal%20tones%20minimal%20composition&width=800&height=560&seq=gossip-a10&orientation=landscape",
    tags: ["新歌", "先行曲", "争议"],
    heat: 4160000,
    comments: 2560,
    featured: false,
    content: [
      "暌违两年，这位歌手用一首风格大转的先行曲宣布回归。歌曲上线不到一小时，评论区就被两派观点填满。",
      "支持的一方认为，放弃以往的抒情路线、转向更实验的编曲，是勇敢的自我突破；质疑的一方则觉得，旋律记忆点明显减弱。",
      "有意思的是，两边的讨论都没有上升到人身攻击，反而有不少人认真分析编曲结构，这在近期的歌曲讨论里并不常见。",
      "专辑正式版将于下月发行，届时这场讨论或许会有新的答案。",
    ],
  },
  {
    id: "a11",
    title: "恋综最新一期走向反转，剪辑细节被网友逐帧分析",
    summary:
      "最新一期恋爱综艺用一次反转结局把讨论度拉满，观众甚至开始逐帧分析预告里的镜头顺序，试图找出节目组的剪辑逻辑。",
    category: "综艺热点",
    categorySlug: "variety",
    author: "综艺放大镜",
    date: "2026-09-05",
    readTime: "6 分钟",
    image: "https://readdy.ai/api/search-image?query=seaside%20villa%20terrace%20at%20golden%20hour%20with%20warm%20sunlight%20abstract%20editorial%20visual%20peach%20and%20cream%20tones%20minimal%20romantic%20composition&width=800&height=560&seq=gossip-a11&orientation=landscape",
    tags: ["恋综", "反转", "剪辑"],
    heat: 3840000,
    comments: 1980,
    featured: false,
    content: [
      "这档恋爱综艺向来以「不按套路出牌」著称，最新一期更是用一个出乎意料的走向把观众的讨论欲望彻底点燃。",
      "节目播出后，有网友把预告片和正片的镜头顺序做了对比，发现几处画面的排列被重新调整，并据此推测节目组有意控制信息节奏。",
      "节目组暂未回应这些分析，但相关话题的讨论量在两天内都没有降下来。",
      "无论剪辑是否存在引导，这种边看边「办案」的观综方式，本身已经成了这档节目的一部分。",
    ],
  },
  {
    id: "a12",
    title: "时尚品牌官宣新代言人，话题阅读量一夜之间破亿",
    summary:
      "一个向来低调的品牌突然官宣全新代言人，配图风格与以往完全不同，话题阅读量在几个小时内就突破了亿级。",
    category: "时尚红毯",
    categorySlug: "fashion",
    author: "造型观察室",
    date: "2026-09-05",
    readTime: "4 分钟",
    image: "https://readdy.ai/api/search-image?query=fashion%20brand%20campaign%20set%20with%20warm%20golden%20backdrop%20and%20fabric%20draping%20abstract%20editorial%20visual%20minimal%20cream%20and%20amber%20tones&width=800&height=560&seq=gossip-a12&orientation=landscape",
    tags: ["代言", "品牌", "话题"],
    heat: 3520000,
    comments: 1420,
    featured: false,
    content: [
      "这个一向以低调著称的品牌在昨天傍晚发布了一条官宣动态，配图是大量暖金色调的棚拍作品，与品牌以往冷峻的视觉语言判若两人。",
      "官宣发出后，话题阅读量在几个小时内突破亿级，品牌旗舰店的同系列单品搜索量也同步上涨。",
      "有营销从业者分析，这次转向说明品牌正在主动拉近与年轻消费者的距离，「换的不只是代言人，还有整套视觉体系」。",
      "目前品牌方尚未公布完整的广告片，只放出了三张概念图，吊足了期待。",
    ],
  },
];